import React from 'react';

import styled from 'styled-components';

interface BarProps {
  $isSidebarOpen: boolean;
}

const HamburgerMenuWrapper = styled.span<BarProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
`;

const Bar = styled.span<BarProps>`
  height: 0.125rem;
  width: 100%;
  background-color: black;
  transition: all 0.3s ease;

  &:first-child {
    transform: ${({ $isSidebarOpen }) =>
      $isSidebarOpen ? 'rotate(45deg) translate(0, 0)' : 'rotate(0) translate(0, 0)'};
    transform-origin: 0.3125rem;
  }

  &:nth-child(2) {
    transform: ${({ $isSidebarOpen }) =>
      $isSidebarOpen ? 'rotate(-45deg) translate(0, 0)' : 'rotate(0) translate(0, 0)'};
    transform-origin: 0.0625rem;
  }
`;

const HamburgerMenuToggle: React.FC<{ isSidebarOpen: boolean }> = ({ isSidebarOpen }) => (
  <HamburgerMenuWrapper $isSidebarOpen={isSidebarOpen}>
    <Bar $isSidebarOpen={isSidebarOpen} />
    <Bar $isSidebarOpen={isSidebarOpen} />
  </HamburgerMenuWrapper>
);

export default HamburgerMenuToggle;
